<template>
    <div class="videopage">
        <div class="logo"><img src="../assets/logo.png" alt="logo"></div>
        <div class="video-player">
            <video ref="videoplayer" id="videoElement" v-bind:src="urlVideo" autoplay @ended="goBack"></video>
        </div>
        <div class="button-home">
            <img src="../assets/buttons/back.png" alt="home" @click="goBack">
        </div>
        <div class="button-play" :hidden="isPlaying" @click="playVideo"><img src="../assets/buttons/play.png"></div>
        <div class="button-stop" :hidden="!isPlaying" @click="stopVideo"><img src="../assets/buttons/pause.png"></div>
    </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';

export default {
    name: 'Video',
    props: ["fileId"],
    data() {
        return {
            urlVideo: '',
            isPlaying: true
        }
    },
    methods: {
        goBack: () => {
            router.push('/reuniekaart');
        },
        playVideo() {
            // console.log('spelen!');
            this.videoElement.play();
            this.isPlaying = true;
        },
        stopVideo() {
            // console.log('stoppen!');
            this.videoElement.pause();
            this.isPlaying = false;
        }
    },
    created() {
        axios.get(config.api + 'files/' + this.fileId +'?key=' + config.api_key)
        .then((videoRes) => {
            // console.log('stillresult: ' + JSON.stringify(videoRes.data.file_urls.original));
            this.urlVideo = videoRes.data.file_urls.original;
        })
        .catch();
    },
    mounted() {
        // this.videoElement.onended = this.goHome();
    },
    computed: {
        videoElement() {
            return this.$refs.videoplayer;
        }
    }
}
</script>

<style>
.videopage {
    background-color: #cccc99;
    width: 1920px;
    height: 1080px;
    overflow: hidden;
}
.video-player {
    position:absolute;
    width: 1280px;
    height: 720px;
    top: 180px;
    left: 320px;
}
video {
    width: 1280px;
    height: 720px;
}
.logo {
    position: absolute;
    top: 80px;
    left: 1645px;
    width: 120px;
    height: auto;
}
.logo img {
    width: 100%;
    height: auto;
}
.button-home {
    position: absolute;
    top: 117px;
    left: 60px;
    width: 45px;
}
.button-home img {
    width: 100%;
    height: auto;
}
.button-play {
    position: absolute;
    bottom: 80px;
    left: 920px;
    /* width: 100px; */
}
.button-play img {
    height: 80px;
    width: auto;
}
.button-stop {
    position: absolute;
    bottom: 80px;
    left: 920px;
    /* width: 100px; */
}
.button-stop img {
    height: 80px;
    width: auto;
}
</style>